import { Clock } from "lucide-react";

export function Timer({ seconds, total }) {
  const pct = total > 0 ? (seconds / total) * 100 : 0;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const isLow = seconds <= 30;
  return (
    <div className="flex items-center gap-2" data-testid="quiz-timer">
      <Clock className={`w-4 h-4 ${isLow ? "text-red-500 animate-pulse" : "text-slate-500"}`} />
      <span className={`text-sm font-mono font-bold ${isLow ? "text-red-500" : "text-slate-700"}`}>
        {mins}:{secs.toString().padStart(2, "0")}
      </span>
      <div className="w-24 h-1.5 rounded-full bg-slate-200 overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-1000 ${isLow ? "bg-red-500" : "bg-emerald-500"}`}
          style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
